import { ApiClient } from './client';
import { bindAuth } from './methods/auth';
import { bindStaff } from './methods/staff';
import { bindDashboard } from './methods/dashboard';
import { bindStudents } from './methods/students';
import { bindStaffAttendance } from './methods/staff-attendance';
import { bindStaffLeave } from './methods/staff-leave';
import { bindTeacherPortal } from './methods/teacher-portal';
import { bindClasses } from './methods/classes';
import { bindSubjects } from './methods/subjects';
import { bindSchool } from './methods/school';
import { bindLibrary } from './methods/library';
import { bindFees } from './methods/fees';
import { bindGrades } from './methods/grades';
import { bindExams } from './methods/exams';
import { bindReportCards } from './methods/report-cards';
import { bindTransport } from './methods/transport';
import { bindHostel } from './methods/hostel';
import { bindCertificates } from './methods/certificates';
import { bindHomework } from './methods/homework';
import { bindProcurement } from './methods/procurement';
import { bindInventory } from './methods/inventory';
import { bindExclusiveOps } from './methods/exclusive-ops';
import { bindModules } from './methods/modules';
import { bindRbac } from './methods/rbac';
import { bindCommunication } from './methods/communication';
import { bindSecurity } from './methods/security';
import { bindHolidays } from './methods/holidays';
import { bindTimetable } from './methods/timetable';
import { bindSuperAdmin } from './methods/super-admin';
import { bindAiQuestions } from './methods/ai-questions';
import { bindPortal } from './methods/portal';
import { bindMedia } from './methods/media';
import { bindNotifications } from './methods/notifications';
import { bindBulkJobs } from './methods/bulk-jobs';
import { bindAdmissions } from './methods/admissions';
import { bindWebsite } from './methods/website';
import { bindDocumentVerifications } from './methods/document-verifications';
import { bindAnnouncements } from './methods/announcements';
import { bindCanteen } from './methods/canteen';
import { bindCareers } from './methods/careers';
import { bindExpenses } from './methods/expenses';

export interface ApiService extends ApiClient, ReturnType<typeof bindAuth>, ReturnType<typeof bindStaff>, ReturnType<typeof bindDashboard>, ReturnType<typeof bindStudents>, ReturnType<typeof bindStaffAttendance>, ReturnType<typeof bindStaffLeave>, ReturnType<typeof bindTeacherPortal>, ReturnType<typeof bindClasses>, ReturnType<typeof bindSubjects>, ReturnType<typeof bindSchool>, ReturnType<typeof bindLibrary>, ReturnType<typeof bindFees>, ReturnType<typeof bindGrades>, ReturnType<typeof bindExams>, ReturnType<typeof bindReportCards>, ReturnType<typeof bindTransport>, ReturnType<typeof bindHostel>, ReturnType<typeof bindCertificates>, ReturnType<typeof bindHomework>, ReturnType<typeof bindProcurement>, ReturnType<typeof bindInventory>, ReturnType<typeof bindCanteen>, ReturnType<typeof bindExpenses>, ReturnType<typeof bindExclusiveOps>, ReturnType<typeof bindModules>, ReturnType<typeof bindRbac>, ReturnType<typeof bindCommunication>, ReturnType<typeof bindSecurity>, ReturnType<typeof bindHolidays>, ReturnType<typeof bindTimetable>, ReturnType<typeof bindSuperAdmin>, ReturnType<typeof bindAiQuestions>, ReturnType<typeof bindPortal>, ReturnType<typeof bindMedia>, ReturnType<typeof bindNotifications>, ReturnType<typeof bindBulkJobs>, ReturnType<typeof bindAdmissions>, ReturnType<typeof bindWebsite>, ReturnType<typeof bindDocumentVerifications>, ReturnType<typeof bindAnnouncements>, ReturnType<typeof bindCareers> {}

export class ApiService extends ApiClient {
  constructor(baseUrl?: string) {
    super(baseUrl);
    Object.assign(
      this,
      bindAuth(this),
      bindStaff(this),
      bindDashboard(this),
      bindStudents(this),
      bindStaffAttendance(this),
      bindStaffLeave(this),
      bindTeacherPortal(this),
      bindClasses(this),
      bindSubjects(this),
      bindSchool(this),
      bindLibrary(this),
      bindFees(this),
      bindGrades(this),
      bindExams(this),
      bindReportCards(this),
      bindTransport(this),
      bindHostel(this),
      bindCertificates(this),
      bindHomework(this),
      bindProcurement(this),
      bindInventory(this),
      bindCanteen(this),
      bindExpenses(this),
      bindExclusiveOps(this),
      bindModules(this),
      bindRbac(this),
      bindCommunication(this),
      bindSecurity(this),
      bindHolidays(this),
      bindTimetable(this),
      bindSuperAdmin(this),
      bindAiQuestions(this),
      bindPortal(this),
      bindMedia(this),
      bindNotifications(this),
      bindBulkJobs(this),
      bindAdmissions(this),
      bindWebsite(this),
      bindDocumentVerifications(this),
      bindAnnouncements(this),
      bindCareers(this),
    );
  }
}

export const apiService = new ApiService();
